var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{isolation:isolate;}.cls-3{fill:#fff;}.cls-4,.cls-2{fill:#10273d;}.cls-2{font-family:Times-Italic, Times;font-size:12px;font-style:italic;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_16608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m6,11.5c-3.03,0-5.5-2.47-5.5-5.5S2.97.5,6,.5s5.5,2.47,5.5,5.5-2.47,5.5-5.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m6,1C3.24,1,1,3.24,1,6s2.24,5,5,5,5-2.24,5-5S8.76,1,6,1m0-1c3.31,0,6,2.69,6,6s-2.69,6-6,6S0,9.31,0,6,2.69,0,6,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4 10)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.55b693239e6167bbcef1c896259d9dc5.svg";
export { ForwardRef as ReactComponent };